"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("components");
const ExistsEDS = () => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "max-width-600 min-height-600 mar-auto flex-center pad-20 align-start-touch", children: (0, jsx_runtime_1.jsx)(components_1.H3, { children: "Thank you for your interest. You have an existing account with us. Please contact our support team for further assistance." }) }));
};
exports.default = ExistsEDS;
